import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b6eb6202&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b6eb6202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eb6202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6eb6202')) {
      api.createRecord('b6eb6202', component.options)
    } else {
      api.reload('b6eb6202', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b6eb6202&scoped=true&", function () {
      api.rerender('b6eb6202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221B2NMxSpiin/JS/comp/DocBox.vue"
export default component.exports